import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Calendar, User, ArrowRight, ExternalLink } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useTranslate } from '../hooks/useTranslate';
import { OptimizedImage } from './ui/optimized-image';

const NewsCard = ({ article, onReadArticle, formatDate, getExcerpt, articleLabelTranslated, byTranslated, readArticleTranslated }) => {
  const { currentLanguage } = useLanguage();
  
  // Traduire le titre et le contenu de la carte
  const { translatedText: titleTranslated } = useTranslate(article.title);
  const { translatedText: excerptTranslated } = useTranslate(getExcerpt(article.content));

  return (
    <Card className="group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden">
      {article.cover_image && (
        <div className="aspect-video bg-gray-100 relative overflow-hidden">
          <OptimizedImage 
            src={article.cover_image} 
            alt={article.title}
            className="w-full h-full object-cover"
            useThumbnail={true}
          />
          <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center">
            <ExternalLink className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-all duration-300 transform scale-75 group-hover:scale-100" />
          </div>
          <div className="absolute bottom-4 left-4 bg-white bg-opacity-90 rounded-lg px-3 py-1">
            <span 
              className="font-semibold text-sm" 
              style={{ color: 'rgb(196, 150, 96)' }}
            >
              {articleLabelTranslated}
            </span>
          </div>
        </div>
      )}
      
      <CardContent className="p-6">
        <div 
          className="flex items-center text-base text-gray-500 mb-4 space-x-4"
          style={{ fontFamily: '"Lora", serif' }}
        >
          <div className="flex items-center">
            <User className="w-4 h-4 mr-1" />
            <span>{byTranslated}: Les lignages de Bruxelles</span>
          </div>
          <div className="flex items-center">
            <Calendar className="w-4 h-4 mr-1" />
            <span>{formatDate(article.published_at)}</span>
          </div>
        </div>
        
        <h3 
          className="text-2xl font-bold mb-3 transition-colors line-clamp-2"
          style={{ 
            fontFamily: '"Lora", serif',
            color: 'rgb(196, 150, 96)'
          }}
        >
          {currentLanguage === 'fr' ? article.title : titleTranslated}
        </h3>
        
        <p 
          className="text-gray-600 leading-relaxed mb-6 line-clamp-3"
          style={{ fontFamily: '"Lora", serif', fontSize: '17px' }}
        >
          {currentLanguage === 'fr' ? getExcerpt(article.content) : excerptTranslated}
        </p>
        
        <Button 
          variant="outline" 
          className="w-full hover:bg-opacity-10 transition-all duration-300"
          onClick={() => onReadArticle(article)}
          style={{ 
            fontFamily: '"Lora", serif',
            borderColor: 'rgb(196, 150, 96)',
            color: 'rgb(196, 150, 96)'
          }}
        >
          <span>{readArticleTranslated}</span>
          <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" />
        </Button>
      </CardContent>
    </Card>
  );
};

export default NewsCard;
